export default __webpack_public_path__ + "static/media/accelego-logo-dark.8dc98687.svg";